import './jquery';
import 'jquery-ui/dist/jquery-ui';
import 'jquery.cookie';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'jquery-validation/dist/localization/messages_ja';

import './rails';
import './app';
